<!--table 编辑 -->
<template>
  <div class="custom_table_template2">
    <el-card style="margin-top: 10px">
      <div slot="header" style="font-weight: bold">药品信息</div>
      <el-table :data="diagnosis" style="width: 100%">
        <el-table-column label="药品名称" width="200px">
          <template slot-scope="scope1">
            <el-autocomplete
              class="inline-input"
              v-model="diagnosis[scope1.$index].name"
              :fetch-suggestions="querySearch"
              placeholder="请输入药品名称"
              @select="
                (event) => {
                  handleSelect(event, scope1.$index);
                }
              "
              @input="changeInput(scope1.$index)"
            ></el-autocomplete>
          </template>
        </el-table-column>
        <el-table-column label="数量" min-width="150">
          <template slot-scope="scope1">
            <el-input-number
              size="mini"
              v-model="diagnosis[scope1.$index].num"
              :min="1"
              @change="
                (event) => {
                  selectcount(event, scope1.$index);
                }
              "
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="批准文号" prop="list.approvalNumber">
          <template> </template>
        </el-table-column>
        <el-table-column label="规格" prop="list.specification">
          <template> </template>
        </el-table-column>
        <el-table-column label="单位" prop="list.unit">
          <template> </template>
        </el-table-column>
        <el-table-column label="每次剂量" width="100px">
          <!-- prop="" -->
          <template slot-scope="scope1">
            <el-input
              type="text"
              v-model="diagnosis[scope1.$index].dose"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="剂量单位" prop="list.doseUnit">
          <template> </template>
        </el-table-column>
        <el-table-column label="频次" width="150px">
          <template slot-scope="scope1">
            <el-select v-model="diagnosis[scope1.$index].useFrequencyValue">
              <el-option
                v-for="item in diagnosis[scope1.$index].useFrequencyList"
                :key="item.dicCode"
                :label="item.dicName"
                :value="item.dicCode"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="用法" width="100px">
          <template slot-scope="scope1">
            <el-select v-model="diagnosis[scope1.$index].drugUsageValue">
              <el-option
                v-for="item in diagnosis[scope1.$index].drugUsageList"
                :key="item.dicCode"
                :label="item.dicName"
                :value="item.dicCode"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="库存" prop="list.stock">
          <template> </template>
        </el-table-column>
        <el-table-column label="单价" prop="list.price">
          <template> </template>
        </el-table-column>
        <el-table-column label="药品产地" prop="list.originPlace">
          <template> </template>
        </el-table-column>
        <el-table-column label="操作" width="100" header-align="right">
          <template slot-scope="scope">
            <div style="display: flex; justify-content: space-between">
              <el-link
                icon="el-icon-plus"
                size="mini"
                type="primary"
                @click="handleAdd(scope.$index, scope.row)"
                :underline="false"
                style="font-size: 14px; margin-left: 40px"
              ></el-link>
              <el-link
                icon="el-icon-delete"
                size="mini"
                @click="handleDelete(scope.$index, scope.row)"
                type="danger"
                :underline="false"
              ></el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card style="text-align: center">
      <el-button type="primary" @click="add">保存</el-button>
      <el-button type="danger" @click="cancel">重置</el-button>
    </el-card>
    <!-- 保存处方时选择诊断 -->
    <el-dialog title :visible.sync="changeDiagnosis" width="70%">
      <div slot="header" style="font-weight: bold">诊断选择</div>
      <el-table
        :data="diagnosisList"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="diagnosisName" label="诊断名称">
        </el-table-column>
        <el-table-column prop="diagnosisRemark" label="诊断备注">
        </el-table-column>
      </el-table>
      <el-card
        style="
          text-align: center;
          margin-top: 30px;
          box-shadow: 0 0 0 white;
          border: none;
        "
      >
        <el-button type="primary" @click="determine">确定</el-button>
        <el-button type="danger">取消</el-button>
      </el-card>
    </el-dialog>
    <el-card>
      <div slot="header" style="font-weight: bold">处方信息</div>
      <el-col
        :span="12"
        style="border-bottom: 2px solid #ccc"
        v-for="(item, index) in recordList"
        :key="index"
      >
        <div class="grid-content">
          <div slot="header">
            <el-row style="margin-top: 20px"
              >病人姓名：{{ item.patientname }}</el-row
            >
            <el-row>缴费项名称:{{ item.projecttype }}</el-row>
            <el-row>识别序号：{{ item.identificationnumber }}</el-row>
            <el-row>费用日期：{{ item.costdate }}</el-row>
            <el-row>合计金额：{{ item.totalcost }}</el-row>
            <el-row style="padding-bottom: 20px">
              <el-button type="primary" @click="seeDetails(item)"
                >查看明细</el-button
              >
              <el-button type="danger" @click="deletePrescription(item)"
                >删除</el-button
              >
            </el-row>
          </div>
        </div>
      </el-col>
    </el-card>
    <el-dialog title :visible.sync="choiceshow" width="70%">
      <div slot="header" style="font-weight: bold">处方信息</div>
      <el-card v-for="(item,index) in prescriptionDetailsList" :key="index">
      <el-row>患者姓名：{{item.patientname}}</el-row>
      <el-row>药方类型：{{item.insuName}}</el-row>
      <el-row>科室：{{item.admLoc}}</el-row>
      <el-row>类型：{{item.patientnaturedes}}</el-row>
      <el-card v-for="(item1,index1) in item.unpaidDetailInfos" :key="index1">
      <div slot="header" style="font-weight: bold" >{{item1.itemName}} ￥{{item1.itemAmount}}</div>
      <el-table :data="item1.list" style="width: 100%" v-if="item1.list">
        <el-table-column prop="itemName" label="药品名称"> </el-table-column>
        <!-- <el-table-column prop="list.itemnumber" label="项目编号"> </el-table-column> -->
        <el-table-column prop="itemNumber" label="数量"> </el-table-column>
        <el-table-column prop="itemUnit" label="单位"> </el-table-column>
        <el-table-column prop="itemUnitPrice" label="价格"> </el-table-column>
        <el-table-column prop="usage" label="给药途径"> </el-table-column>
        <el-table-column prop="feq" label="用法用量"> </el-table-column>
      </el-table>
      </el-card>
      </el-card>
    </el-dialog>
  </div>
</template>
<script>
import { Message } from "element-ui";
import axiosUtil from "../../utils/AxiosUtils.js";
export default {
  data() {
    return {
      textarea: "",
      choiceshow: false,
      form: {},
      diagnosis: [
        {
          num: 1,
          dose: "",
          drugUsageList: null,
          useFrequencyList: null,
          useFrequencyValue: "",
          drugUsageValue: "",
        },
      ],
      state1: "",
      restaurants: [],
      list: [
        {
          costname: "布洛芬缓释胶囊",
          itemnumber: "1",
          price: "5.39",
          amount: "5.39",
          unit: "合",
          plasters: "1",
          usage: "口服",
          feq: "两次/日",
        },
        {
          costname: "金莲花软胶囊",
          itemnumber: "1",
          price: "52.35",
          amount: "52.35",
          unit: "盒",
          plasters: "1",
          usage: "口服",
          feq: "三次/日",
        },
      ],
      num: 1,
      qKey: "",
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      value: "",
      singleDoseList: [],
      drugUsageList: [],
      useFrequencyList: [],
      recordList: [],
      changeDiagnosis: false,
      diagnosisList: [],
      multipleSelection: [],
      prescriptionDetailsList:[]
    };
  },
  props: {
    ddid: {
      type: String,
    },
  },
  mounted() {
    this.loadList();
    this.loaddrugs();
  },
  methods: {
    //获取当前日期
    getDate() {
      var _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      return yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
    },
    //确定诊断 验证保存处方
    determine() {
      let _this = this;
      if (JSON.stringify(this.multipleSelection) == "[]") {
        Message({
          showClose: true,
          message: "请选择诊断",
          type: "error",
        });
        return;
      }

      let array = [];
      for (let i in _this.diagnosis) {
        let obj = {};
        obj.code = _this.diagnosis[i].list.drugCode;
        obj.name = _this.diagnosis[i].list.name;
        obj.count = _this.diagnosis[i].num;
        obj.unit = _this.diagnosis[i].list.unit;
        obj.dose = _this.diagnosis[i].list.dose;
        obj.doseUnit = _this.diagnosis[i].list.doseUnit;
        obj.frequency = _this.diagnosis[i].useFrequencyValue;
        obj.usage = _this.diagnosis[i].drugUsageValue;
        obj.price = _this.diagnosis[i].list.price;
        obj.prescriptionCount = "1";
        array.push(obj);
      }
      for (let i in _this.multipleSelection) {
        _this.multipleSelection[i].ICD10Code =
          _this.multipleSelection[i].diagnosisCode;
      }
      axiosUtil(
        {
          service: "smarthos.yygh.bjyl.prescription.medical.check",
          bookId: _this.ddid,
          prescriptionDate: _this.getDate(),
          allergicDrugs: "",
          diagnosisList: JSON.stringify(_this.multipleSelection),
          prescriptionDetailList: JSON.stringify(array),
        },
        ({ code, list, msg }) => {
          if (code == "0") {
            _this.changeDiagnosis = false;
            _this.diagnosis = [
              {
                num: 1,
                dose: "",
                drugUsageList: null,
                useFrequencyList: null,
                useFrequencyValue: "",
                drugUsageValue: "",
              },
            ];
            Message({
              showClose: true,
              message: "开方成功",
              type: "success",
            });
            _this.loadList();
          }
        }
      );
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //保存
    add() {
      let _this = this;
      if (!this.diagnosis[0].list) {
        Message({
          showClose: true,
          message: "请先输入药品",
          type: "error",
        });
        return;
      }
      for (let i in _this.diagnosis) {
        if (_this.diagnosis[i].drugUsageValue == "") {
          Message({
            showClose: true,
            message: "请选择频次",
            type: "error",
          });
          return;
        }
        if (_this.diagnosis[i].useFrequencyValue == "") {
          Message({
            showClose: true,
            message: "请选择用法",
            type: "error",
          });
          return;
        }
      }
      this.getDiagnosisList();
      this.changeDiagnosis = true;
    },
    //删除处方
    deletePrescription(item) {
      let _this = this;
      if (item.invoicenumber == "") {
        axiosUtil(
          {
            service: "smarthos.yygh.medical.prescription.cancel",
            identificationnumber: item.identificationnumber,
            hosid: "01001",
          },
          ({ code, msg }) => {
            if (code == "0") {
              Message({
                showClose: true,
                message: "删除处方成功",
                type: "success",
              });
              _this.loadList();
            }
          }
        );
      } else {
        Message({
          showClose: true,
          message: "处方已交费,不能删除",
          type: "error",
        });
      }
    },
    //填写完药品后选择诊断 获取诊断列表
    getDiagnosisList() {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.yygh.select.medical.records.diagnosis",
          orderId: _this.ddid,
          hosId: "01001",
        },
        ({ code, list, msg }) => {
          if (code == "0") {
            if (JSON.stringify(list) != "[]") {
              _this.diagnosisList = list;
            }
          }
        }
      );
    },
    //重置
    cancel() {
      let _this = this;
      _this.diagnosis = [
        {
          num: 1,
          dose: "",
          drugUsageList: null,
          useFrequencyList: null,
          useFrequencyValue: "",
          drugUsageValue: "",
        },
      ];
    },
    //改变药品数量
    selectcount(value, idx) {
      if (!this.diagnosis[idx].list) {
        Message({
          showClose: true,
          message: "请先选择药品",
          type: "error",
        });
        this.$nextTick(() => {
          this.diagnosis[idx].num = 1;
        });
      } else {
        if (value > this.diagnosis[idx].list.stock) {
          Message({
            showClose: true,
            message: "库存不足",
            type: "error",
          });
          this.$nextTick(() => {
            this.diagnosis[idx].num = this.diagnosis[idx].list.stock;
          });
        }
      }
    },
    //查询药品
    loaddrugs() {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.yygh.medical.list.by.name",
          hosid: "01001",
          drugName: _this.qKey,
        },
        ({ code, drugEntityList, msg }) => {
          if (code == "0") {
            if (JSON.stringify(drugEntityList)!='[]') {
              drugEntityList.map((item) => {
                item.value = item.name;
                return item;
              });
              _this.restaurants = drugEntityList;
            } else{
              Message({
                showClose: true,
                message: "暂无查询到此药品",
                type: "error",
              });
              _this.restaurants=[]
            }
          }
        }
      );
    },
    //查询处方列表
    loadList() {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.yygh.select.prescribe.record.list",
          orderId: _this.ddid,
        },
        ({ code, recordList, msg }) => {
          if (code == "0") {
            _this.recordList = recordList;
          }
        }
      );
    },
    //查看明细
    seeDetails(item) {
      let _this = this;
      axiosUtil(
        {
          service:"smarthos.yygh.ApiHosPayService.medical.insurance.queryPendPayList.new",
          ddid: _this.ddid,
        },
        ({ code, list, msg }) => {
          if (code == "0") {
            _this.prescriptionDetailsList=list;
          }
        }
      );
      this.choiceshow = true;
    },
    changeInput(idx) {
      this.qKey = this.diagnosis[idx].name;
      this.loaddrugs();
    },
    querySearch(queryString, cb) {
      // 调用 callback 返回建议列表的数据
      cb(this.restaurants);
    },
    handleSelect(item, idx) {
      this.diagnosis[idx].list = item;
      this.diagnosis[idx].dose = item.dose;
      this.qKey = "";
      this.loaddrugs();
      this.getDictionaries(idx);
    },
    //获取使用频次 用法字典
    getDictionaries(idx) {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.drugs.online.prescription.dictionary",
        },
        ({ code, obj, msg }) => {
          if (code == "0") {
            _this.diagnosis[idx].drugUsageList = obj.drugUsageList;
            _this.diagnosis[idx].useFrequencyList = obj.useFrequencyList;
          }
        }
      );
    },
    handleAdd(index, row) {
      this.diagnosis.push({
        list: {},
        num: 1,
        dose: "",
        drugUsageList: null,
        useFrequencyList: null,
      });
    },
    handleDelete(index, row) {
      if (index > 0) {
        this.diagnosis.splice(index, 1);
      }
    },
  },
};
</script>
<style lang="scss">
.custom_table_template2 {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
